module.exports = __webpack_public_path__ + "static/img/07.7989c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/07.png
// module id = eVUf
// module chunks = 1